<template>
    <a @click="showMap()" class="map-toggle">
        <img src="@/assets/map-icon.png" class="map-toggle__icon"/>
        <span class="map-toggle__text">Открыть карту</span>
    </a>
</template>
<style lang="stylus">
    @import "~@/assets/styles/sizes.styl";

    .map-toggle
        display flex
        align-items center
        margin-top vw(16, $desktop)
        &:hover
            filter brightness(1.1)
        +mobile()
            justify-content center
        &__icon
            width vw(20, $desktop)
            +mobile()
                width vw(20, $mobile)
        &__text
            cursor pointer
            white-space nowrap
            margin-left vw(10, $desktop)
            font-size vw(11, $desktop)
            font-weight bold
            color #cb993f
            border-bottom 1px solid #cb993f
            +mobile()
                margin-left vw(10, $mobile)
                font-size vw(12, $mobile)
</style>
<script>
    export default {
        methods: {
            showMap() {
                this.$ga.event('internal','click', 'map_open');
                localStorage._scrollY = window.scrollY;
                this.$router.push('/map?return='+this.$route.path);
            }
        }
    }
</script>